import { PlanetFilterInput, SkillFilterMode } from '@apeiron/planet'
import PlanetSkillFilter from '@src/components/planet/filter/skillFilter/PlanetSkillFilter'
import { FC } from 'react'

const PlanetCardSkillFilter: FC<Props> = (props: Props) => {
  const { className, filterOptions, onFilterOptionsChange } = props

  return (
    <PlanetSkillFilter
      className={className}
      mode={SkillFilterMode.Active}
      filterOptions={filterOptions}
      onFilterOptionsChange={onFilterOptionsChange}
    />
  )
}

type Props = {
  className?: string
  filterOptions: PlanetFilterInput
  onFilterOptionsChange: (input: PlanetFilterInput) => void
}

export default PlanetCardSkillFilter
